
export * from './src/user-admin-domain'

        import * as me from '@peachy/web-dashboard-pure'
        
        Object.entries(me).forEach(([exportedAs, exported]) => {
            if (exported && Object.isExtensible(exported)) {
                exported[Symbol.for('__WORKSPACE_HOME')] = '/Users/dan-parker/workspace/peachy-repo/apps/web-dashboard/pure'
                exported[Symbol.for('__WORKSPACE_NAME')] = '@peachy/web-dashboard-pure'
                exported[Symbol.for('__EXPORTED_AS')] = exportedAs
            }
        })
    